<template>
  <div class="input_container field-wrapper">
    <van-field 
      v-model="localValue" 
      type="number" 
      :placeholder="labelText" 
        class="custom-field"
       :class="{ 'has-value': localValue }"
      :border="false"
    >
      <template #left-icon>
        <div class="left-section">
          <span class="left_icon">R$</span>
        </div>
      </template>

      <template #button>       
        <div class="right-section">
           <van-icon v-if="localValue" name="clear" class="custom-clear" @click.stop="onClear" /> 
          <div class="step-arrows">
            <van-icon name="arrow-up" class="step-icon" @click="increment" />
            <van-icon name="arrow-down" class="step-icon" @click="decrement" />
          </div>
          
          <button type="button" class="max-btn" @click.stop="handleMaxClick">
            Máx.
          </button>
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  labelText: {
    type: String,
    default: '20,00 - 50.000,00'
  },
  maxLimit: {
    type: Number,
    default: 50000
  }
})

const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
  localValue.value = newVal  
})

watch(localValue, (val) => {
  emit('update:modelValue', val)
  emit('valueChanged', val)
})

const handleMaxClick = () => {
  localValue.value = props.maxLimit
}

const increment = () => {
  const val = Number(localValue.value) || 0
  localValue.value = val + 1
}

const decrement = () => {
  const val = Number(localValue.value) || 0
  if (val > 0) localValue.value = val - 1
}

const onClear = () => {
  localValue.value = ''
  emit('update:modelValue', '')
  emit('valueChanged', '')
}
</script>

<style scoped>

.field-wrapper {
  width: 100%;
}

.input_container :deep(.van-field) {
  border-radius: 8px;
  background: #002121 !important;
  padding: 8px 12px !important;
  align-items: center;
  height: 55px;
  transition: all 0.25s ease;
}

.input_container :deep(.van-field) {
  border: 1px solid #0db0ae87; 
}

.field-wrapper:focus-within :deep(.van-field) {
  border: 1.5px solid #0db0ae; 
}

.input_container :deep(.van-field.has-value) {
  border: 1.5px solid rgb(83, 193, 84);
}

.left_icon {
  color: #FBA531; 
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.input_container :deep(.van-field__control) {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 18px;
}

.input_container :deep(.van-field__control::placeholder) {
  color: #4a6b6a !important;
  font-weight: 700;
}

.right-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-arrows {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #1a2e2d;
  border-radius: 4px;
  padding: 2px 4px;
 
  opacity: 0;
  pointer-events: none;
  transform: translateX(5px);
  transition: all 0.25s ease-in-out;
}

.field-wrapper:hover .step-arrows,
.field-wrapper:focus-within .step-arrows {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
}

.step-icon {
  font-size: 12px;
  color: #555;
  cursor: pointer;
  padding: 1px 0;
  transition: color 0.2s;
}

.step-icon:hover {
  color: #FBA531;
}

.max-btn {
  background-color: #043836;
  border: 1px solid #005a58;
  color: #5ea19f;
  border-radius: 6px;
  padding: 0 12px;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.max-btn:active {
  background-color: #005a58;
  color: #fff;
}

@media (max-width: 360px) {
  .input_container :deep(.van-field) {
    height: 48px;
  }

  .left_icon, 
  .input_container :deep(.van-field__control) {
    font-size: 15px;
  }

  .max-btn {
    height: 30px;
    font-size: 13px;
    padding: 0 8px;
  }
}
</style>